var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkdinIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_953_22528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 0C6.26719 0 0 6.26719 0 14C0 21.7328 6.26719 28 14 28C21.7328 28 28 21.7328 28 14C28 6.26719 21.7328 0 14 0ZM10.0844 19.857H7.35547V11.1234H10.0844V19.857ZM8.64609 10.0297H8.62422C7.63437 10.0297 6.99453 9.3625 6.99453 8.51484C6.99453 7.65078 7.65625 7 8.6625 7C9.66875 7 10.2867 7.65078 10.3086 8.51484C10.3141 9.35703 9.67422 10.0297 8.64609 10.0297ZM21 19.857H17.9047V15.3398C17.9047 14.1586 17.4234 13.3492 16.357 13.3492C15.5422 13.3492 15.0883 13.8961 14.8805 14.4211C14.8039 14.607 14.8148 14.8695 14.8148 15.1375V19.857H11.7469C11.7469 19.857 11.7852 11.8508 11.7469 11.1234H14.8148V12.4961C14.9953 11.8945 15.9742 11.0414 17.5383 11.0414C19.4797 11.0414 21 12.2992 21 15.0008V19.857Z",
    fill: "#20C3FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_953_22528"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdinIcon);
export default __webpack_public_path__ + "static/media/linkdinIcon.1033d26a0fd04ce62c15468165014e16.svg";
export { ForwardRef as ReactComponent };